import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar } from "@material-ui/core";
import isEmpty from "./is-empty";

const useStyles = makeStyles((theme) => ({
  imageView: {
    // display: 'flex',
    // justifyContent: 'center'
  },
  profileImageUploadFile: {
    display: "none",
  },
  largeAvatar: {
    cursor: "pointer",
    textTransform: "capitalize",
    fontSize: 20,
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
}));

const PhotoUpload = ({
  imageName,
  imageUrl,
  onChange,
  htmlFor,
  disabled,
  style,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.imageView}>
      <input
        disabled={disabled || false}
        className={classes.profileImageUploadFile}
        accept="image/x-png,image/gif,image/jpeg"
        id={htmlFor ? htmlFor : "contained-button-file"}
        type="file"
        onChange={onChange}
        style={style || null}
      />
      <label
        htmlFor={htmlFor ? htmlFor : "contained-button-file"}
        style={{ cursor: disabled ? "default" : "pointer" }}
      >
        <Avatar
          alt={imageName}
          src={!isEmpty(imageUrl) ? imageUrl : null}
          className={classes.largeAvatar}
          style={{ cursor: disabled ? "default" : "pointer" }}
        />
      </label>
    </div>
  );
};

export default PhotoUpload;
